export default __webpack_public_path__ + "static/media/group-order.1328b882.png";